import type {Locale} from '@sail/intl';
import type Headers from 'src/internal/shared/headers/headers';

const ACCEPT_LANGUAGE_HEADER = 'Accept-Language';
const BROWSER_LANGUAGE_HEADER = 'Browser-Language';

export default function addLanguageHeaders(
  headers: Headers,
  locale: Locale,
): void {
  const browserLanguages = Array.from(navigator.languages) || [];

  if (!headers.get(ACCEPT_LANGUAGE_HEADER)) {
    const deduplicatedLanguages = Array.from(
      new Set([locale as string].concat(browserLanguages)),
    );

    headers.set(ACCEPT_LANGUAGE_HEADER, deduplicatedLanguages);
  }

  // This header is needed to handle language mismatches in the
  // Dashboard. We should find a better way to accomplish this.
  // More info: https://docs.google.com/document/d/18kwHV0fMi9ldfLtyBm2jQall3w3JTTSTBZqpDpVfD-Y/edit?pli=1&tab=t.0#heading=h.y4jm2xo7p0np
  if (!headers.get(BROWSER_LANGUAGE_HEADER)) {
    headers.set(BROWSER_LANGUAGE_HEADER, browserLanguages);
  }
}
